
import { Box, Modal } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useState, useRef, useEffect } from "react";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};
const BoqDescriptionModal = (props) => {
    useEffect(() => {

    }, []);


    return (
        <>
            <Modal
                open={props.isModalOpen}
                onClose={() => props.setIsModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className="modal_react_controlpanel_employee">
                    <div className="modal-header">
                        <h5 className="modal-titles" id="uploadexcelfileLabel">
                            Description
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => props.setIsModalOpen(false)}
                        ></button>
                    </div>
                    <div className="modal-body lets_modal_body_block_listing">
                        <div id="vendorForm">
                            <div className="lets_modal_vendor2">
                                <textarea className="form-control form-h choose" style={{ height: '160px' }}
                                    value={props.modalDescription}
                                    onChange={(e) => props.setModalDescription(e.target.value)}
                                    disabled={props.isDisablee}
                                />
                                {!props.isDisablee &&
                                    <div className="clear_btn_status" style={{ float: 'right' }}>
                                        <button type="button"
                                            class="btn btn-success save_next_btns"
                                            fdprocessedid="cn5f6" onClick={props.handleModalSubmit}>Submit</button>
                                        <button type="button"
                                            class="btn btn-success save_next_btns"
                                            fdprocessedid="cn5f6" onClick={() => props.setIsModalOpen(false)}>Close</button>
                                    </div>
                                }

                            </div>
                        </div>
                    </div>



                </Box>
            </Modal>
        </>
    );
};

export default BoqDescriptionModal;